<template>
  <div class="photo-toast-new" :class="{fromType, 'big-photo-container': isBigPhotoToast, 'guoqing': isGuoQing}" v-show="visible">
    <div class="mask"></div>
    <div class="toast-header">
      <img v-if="newClose" class="close-btn-new" src="../../../imgs/icon/toast-top-close.png" alt="关闭"  @click="handleClose" />
      <div v-else class="close-btn" @click="handleClose"></div>
    </div>
    <div class="toast-content">
      <div class="content-bg">
        <progressive-img :src="backgroundImg" :placeholder="backgroundImg + '?imageView2/0/w/38'" />
      </div>
      <div class="content">
        <template v-if="!hasPrivilege&&isShowTopPrice">
          <div class="price">限时￥{{ parentParams.price / 100 }}<span>原价19.9</span></div>
        </template>
        <div v-if="isShowAvatar" class="avatar-wrap" :style="avatarStyle">
          <img class="avatar" :src="user_img || defaultAvatar" alt="头像">
        </div>
        <div class="photo-container">
          <div class="photo-container-inner" :class="shouldEnableScroll && 'photos-centered'">
            <div class="photo-list" v-if="uploadedPics.length > 0">
              <div class="photo-item" v-for="(pic, index) in uploadedPics" :key="index">
                <div class="remove-icon" @click="deletePhoto(index)"></div>
                <div class="photo-preview" :style="`background-image: url(${pic});`"></div>
              </div>
            </div>
            <div class="photo-upload" v-if="uploadedPics.length < imgnum" :style="customUploadBg" @click="uploadPhoto">
              <div class="upload-icon"></div>
              <p>上传照片({{ uploadedPics.length }}/{{ imgnum }})</p>
              <span class="notification-dot"></span>
            </div>
          </div>
        </div>

        <div class="bottom-section">
          <!-- 优先显示自定义tag，没有自定义tag时显示原逻辑 -->
          <template v-if="!hasPrivilege&&!isShowTopPrice">
            <div v-if="customTagText" class="price-tag">{{ customTagText }}</div>
            <div v-else class="price-tag"><span v-if="isShowXS">限时</span>￥{{ parentParams.price / 100 }}</div>
          </template>
          <div v-if="showCountdownBtn" class="countdown-btn" :class="buttonAnimationClass" :style="customButtonStyle" @click="handleSendPhoto">
            <div class="btn-text" :style="customBtnTextStyle">{{ dynamicButtonText }}</div>
            <!-- 新增倒计时 -->
            <div v-if="!hasPrivilege&&showCountdown" class="countdown">
              <span>{{ formatTime }}</span>后恢复原价19.9元
            </div>
          </div>
          <div v-else-if="showCancelBtn" class="two-btn">
            <div v-if="!hasPrivilege">
              <button class="cancel-btn" @click="handleSendPhoto"></button>
              <button class="pay-btn" @click="handleSendPhoto"></button>
            </div>
            <div v-else class="countdown-btn" :class="buttonAnimationClass">
              <div class="btn-text" @click="handleSendPhoto">{{ dynamicButtonText }}</div>
            </div>
          </div>
          <button v-else class="send-btn" :class="[buttonClass, buttonAnimationClass]" @click="handleSendPhoto">
            {{ dynamicButtonText }}
          </button>
          <div class="cursor" v-if="showCursor">
            <img :src="cursorImg">
          </div>
          <!-- 新增底部文案 -->
          <div v-if="!hasPrivilege&&bottomText" class="bottom-text" :style="bottomTextColor ? { color: bottomTextColor } : {}">{{ bottomText }}</div>
        </div>

        <!-- 新增滚动消息 -->
        <ScrollMessages :show="showScrollMessages" />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import sendPhoto from '@/mixins/send_photo';
import ScrollMessages from './scroll-messages.vue';

export default {
  name: 'PhotoToastNew',
  mixins: [sendPhoto],
  components: {
    ScrollMessages
  },
  data() {
    return {
      visible: false,
      fromType: '',
      backgroundImg: '',
      isShowAvatar: false,
      avatarPosition: {
        top: '7.2vw',
        left: '10vw'
      },
      buttonClass: '',
      buttonText: '发送上屏',
      showCursor: true,
      cursorImg: 'https://qncweb-back1.ktvsky.com/20220818/other/9f00502bfc1234a0b29d6f097f691652.png',
      defaultAvatar: 'https://qncweb-back1.ktvsky.com/20230111/other/b111d8fb43bb9eee0ff9ecd66fe1d32d.png',
      uploadedPics: [],
      hasPrivilege: false,
      parentParams: {},
      entrance: 'photoBT_ordered',
      isLoading: true,
      isShowXS: false,
      showScrollMessages: false,
      showCountdownBtn: false,
      showCountdown: false,
      countdown: 300,
      countdownInterval: null,
      isShowTopPrice: false, // 是否展示上方价格
      showCancelBtn: false, // 是否显示俩个按钮
      newClose: false,
      // 新增配置项
      customTagText: '', // 自定义tag文本，有值时优先显示
      bottomText: '', // 底部文案内容，有值时显示
      bottomTextColor: '', // 新增：底部文案颜色配置
      // 按钮样式配置
      customButtonWidth: null, // 自定义按钮宽度
      customButtonHeight: null, // 自定义按钮高度
      customButtonBg: '', // 自定义按钮背景图
      isBigPhotoToast: false, // 是否是大图弹窗
      customUploadBg: {}, // 自定义上传背景样式对象
      enableHeartbeat: false, // 按钮心跳动效配置
      isGuoQing: false, // 是否为国庆主题
    };
  },
  computed: {
    openid() {
      return store.state.openid;
    },
    unionid() {
      return store.state.unionid;
    },
    photoPag() {
      return store.state.photoPag;
    },
    photoPath() {
      return store.state.photoPath;
    },
    role() {
      return store.state.role;
    },
    user_img() {
      return store.state.user_img;
    },
    avatarStyle() {
      return {
        top: this.avatarPosition.top,
        left: this.avatarPosition.left
      }
    },
    imgnum() {
      return this.photoPath.id === 1 ? 1 : 6;
    },
    formatTime() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = Math.floor(this.countdown % 60);
      const milliseconds = Math.floor((this.countdown % 1) * 100);
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${milliseconds.toString().padStart(2, '0')}`;
    },
    customButtonStyle() {
      const style = {};
      // 只有明确传入自定义参数时才覆盖默认样式
      if (this.customButtonWidth !== null) {
        style.width = typeof this.customButtonWidth === 'number' ? `${this.customButtonWidth}px` : this.customButtonWidth;
      }
      if (this.customButtonHeight !== null) {
        style.height = typeof this.customButtonHeight === 'number' ? `${this.customButtonHeight}px` : this.customButtonHeight;
      }
      if (this.customButtonBg) {
        style.background = `url('${this.customButtonBg}') no-repeat center center`;
        style.backgroundSize = 'contain';
      }
      return style;
    },
    customBtnTextStyle() {
      // 只有明确传入自定义宽度时才覆盖默认文本宽度
      return this.customButtonWidth !== null ? {
        width: typeof this.customButtonWidth === 'number' ? `${this.customButtonWidth}px` : this.customButtonWidth
      } : {};
    },
    // 按钮动效类名计算属性
    buttonAnimationClass() {
      return {
        'heartbeat-animation': this.enableHeartbeat
      };
    },
    // 动态计算按钮文本（国庆主题）
     dynamicButtonText() {
       return this.isGuoQing ? '马上发上屏' : this.buttonText;
     },
    shouldEnableScroll() {
      // 大图模式下，超过1张图片就启用滚动；正常模式下，超过2张图片启用滚动
      const threshold = this.isBigPhotoToast ? 1 : 2;
      return this.uploadedPics.length > threshold;
    }
  },
  beforeCreate() {
    this.$store = store;
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit('close');
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);
      const remainingSlots = this.imgnum - this.uploadedPics.length;
      const filesToProcess = files.slice(0, remainingSlots);

      filesToProcess.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedPics.push(e.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
    deletePhoto(index) {
      this.uploadedPics.splice(index, 1);
    },
    handleSendPhoto() {
      this.$sendLog({
        event_type: 'click',
        event_name: '发照片弹窗-点击',
        event_data: {
          fromType: this.fromType,
          name: this.photoPath.label,
        }
      })
      if (this.hasPrivilege || !this.isLoading) {
        this.$sendLog({
          event_type: 'click',
          event_name: '发照片弹窗-点击发送',
          event_data: {
            fromType: this.fromType,
            name: this.photoPath.label,
          }
        })
      }
      this.handleSend(this.entrance)
    },
    startCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      this.countdownInterval = setInterval(() => {
        this.countdown -= 0.01;
        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval);
          this.showCountdown = false;
        }
      }, 10);
    }
  },
  mounted() {
    // 检查权限
    this.getDefault();
    // 发送展示日志
    this.$sendLog({
      event_type: 'click',
      event_name: '发照片弹窗-展示',
      event_data: {
        fromType: this.fromType,
        name: this.photoPath?.label || '',
      }
    })

    this.entrance = `${this.fromType}_${this.photoPath?.entrance || ''}`

    // 根据参数控制功能
    if (this.showCountdownBtn) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-toast-new {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  .toast-content {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .content-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;

    img,
    .progressive-image,
    .progressive-image-main,
    .progressive-image-placeholder {
      width: 100%;
      display: block;
    }
  }

  .content {
    position: relative;
    z-index: 2;
    padding: 180px 30px 50px;
    margin-bottom: 30px;
  }

  .toast-header {
    position: relative;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .close-btn {
      position: absolute;
      top: 50px;
      right: 30px;
      width: 60px;
      height: 60px;
      background: url('https://qncweb-back1.ktvsky.com/20240912/vadd/2ea871a7ae89d3ddf55722505052ff2f.png') no-repeat center;
      background-size: contain;
    }

    .close-btn-new {
      position: absolute;
      top: 50px;
      right: 30px;
      width: 60px;
      height: 60px;
    }
  }

  .photo-container {
    width: 690px;
    height: 237px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin: 35px auto 40px;
    overflow-x: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .photo-container-inner {
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    justify-content: center;
  }

  .photos-centered {
    width: fit-content;
  }

  .photo-list {
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    width: fit-content;
  }

  .photo-item {
    position: relative;
    width: 212px;
    height: 212px;
    margin: 15px 10px 0 0;
    border-radius: 30px;

    .remove-icon {
      position: absolute;
      top: -15px;
      right: 4px;
      width: 40px;
      height: 40px;
      background: url('https://qncweb.ktvsky.com/20250214/vadd/a9eb91dbebe083ff33369f85f437fefc.png') no-repeat center center;
      background-size: contain;
      z-index: 1;
      cursor: pointer;
    }

    .photo-preview {
      width: 100%;
      height: 100%;
      background-size: cover;
      border: 1px solid #fff;
      border-radius: 30px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .photo-upload {
    width: 212px;
    height: 212px;
    padding-top: 135px;
    color: #000;
    border-radius: 30px;
    background: #fff url('https://qncweb-back1.ktvsky.com/20240912/vadd/4c8af338357ba43fd5201659297d5ec0.png') no-repeat 66px 43px;
    background-size: 80px 80px;
    border: 1px solid #E6E6E6;
    font-size: 25px;
    text-align: center;
    margin-top: 15px;
    position: relative;

    .notification-dot {
      position: absolute;
      top: 45px;
      right: 65px;
      width: 15px;
      height: 15px;
      background-color: #FF334E;
      border-radius: 50%;
      display: inline-block;
    }
  }

  .bottom-section {
    position: relative;
    display: flex;
    justify-content: center;

    .price-tag {
      position: absolute;
      top: -30px;
      left: 430px;
      background: #FF334E;
      color: #fff;
      padding: 3px 10px;
      border-radius: 15px 15px 15px 0;
      font-size: 24px;
      z-index: 100;
    }

    .send-btn {
      width: 618px;
      height: 90px;
      background: #FFC43D;
      color: #000000;
      font-size: 45px;
      font-weight: bold;
      border-radius: 45px;
      border: none;
    }
  }

  .cursor {
    width: 100px;
    position: absolute;
    right: 50px;
    bottom: -20px;
    animation: shakeX 2.5s linear 0s infinite normal;
    animation-fill-mode: both;
  }
}

.big-photo-container {
  .content {
    padding: 140px 30px 50px;
  }
  .photo-container {
    width: 690px;
    height: 315px;
    margin: 35px auto 30px;
  }
  .photo-upload {
    width: 290px;
    height: 290px;
    padding-top: 185px; // 按比例调整padding-top：135px * (290/212) ≈ 185px
    border-radius: 10px;
    border: none;
    .notification-dot{
      position: absolute;
      top: 90px;
      right: 110px;
    }
  }
  .photo-item {
    width: 290px;
    height: 290px;
  }
}

.avatar-wrap {
  position: absolute;

  img {
    width: 66px;
    height: 66px;
    border-radius: 50%;
  }
}

.photoBT_ordered {
  .bottom-section {
    .send-btn {
      background: linear-gradient(180deg, #FF21D3 0%, #FF7CBC 100%);
      color: #FFFC12;
      font-size: 35px;
    }
  }
}

.photoT_homeAvatar {
  .bottom-section {
    .send-btn {
      background: linear-gradient(180deg, #FFEC59 0%, #FFD321 100%);
      color: #341B01;
      font-size: 45px;
    }
  }
}

.countdown-btn {
  width: 66.67vw;
  height: 16.27vw;
  background: url('https://qncweb.ktvsky.com/20250519/vadd/b5ed27da7d6f7ef92e7054c01ac2ecb5.png') no-repeat center center;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  text-align: center;
  .btn-text {
    width: 66.67vw;
    font-size: 36px;
    font-weight: bold;
    color: #3F2508;
  }
}

.countdown {
  text-align: center;
  font-size: 22px;
  font-family: monospace;
}

.photoT_searchResultAd {
  .bottom-section {
    .send-btn {
      width: 690px;
      height: 100px;
      background: linear-gradient(90deg, #FF21D3 0%, #FF7CBC 100%);
      color: #FFFC12;
      font-size: 40px;
      border-radius: 50px;
      box-shadow: 0 4px 12px rgba(255, 33, 211, 0.3);
    }
  }
}

.search-result-btn {
  width: 690px;
  height: 100px;
  background: linear-gradient(90deg, #FF21D3 0%, #FF7CBC 100%);
  color: #FFFC12;
  font-size: 40px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(255, 33, 211, 0.3);
}

.price {
  width: 100%;
  text-align: center;
  position: absolute;
  top: -20px;
  left: 0;
  font-size: 24px;
  color: #FF5050;
  span {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: line-through;
  }
}

.two-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .cancel-btn {
    width: 280px;
    height: 112px;
    background: url('https://qncweb.ktvsky.com/20250520/vadd/12c243e17cc39cf63e44b1b34b23b2de.png') no-repeat center center;
    background-size: contain;
    margin: 0 10px;
  }
  .pay-btn {
    width: 280px;
    height: 112px;
    background: url('https://qncweb.ktvsky.com/20250520/vadd/2479e335eade078d3122f08623b4a4e9.png') no-repeat center center;
    background-size: contain;
    margin: 0 10px;
  }
}

.bottom-text {
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: #ff334e; // 这里保留默认色，动态色用 style 覆盖
  text-align: center;
  white-space: nowrap;
  opacity: 0.5;
}

/* 心跳动效动画 */
.heartbeat-animation {
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.05);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.05);
  }
  70% {
    transform: scale(1);
  }
}
// 国庆主题
.guoqing {
  .content {
    padding: 160px 30px 50px;
  }
  .photo-upload {
    .notification-dot{
      position: absolute;
      top: 80px;
      right: 110px;
    }
  }
  .countdown-btn {
    background: url('https://qncweb.ktvsky.com/20250925/vadd/07319f8926966c5fdae6901b7d330544.png') no-repeat center center;
    background-size: contain;
    .btn-text {
      color: #fff;
    }
  }
  .bottom-section {
    .price-tag {
      position: absolute;
      top: -20px;
      left: 430px;
      background: linear-gradient(270deg, #FF1534 0%, #FF8797 100%);
      border: 2px solid #ffffff;
      color: #fff;
      padding: 3px 10px;
      border-radius: 20px 20px 20px 0;
      font-size: 24px;
      z-index: 100;
    }
  }
  .bottom-text {
    color: #ffffff !important;
  }
}
</style>
